<template>
  <div>
    <items-list
      :businessId="businessId"
      :query="query"
      :filters="filters"
      :targetEntityId="targetEntityId"
      category="orderinprogress"
      @assign="assign"
      @assign-location="assignLocation"
      @history="history"
      @del="del"
    />
  </div>
</template>

<script>
import ItemsList from "@/views/business/todo/components/ItemsList";

export default {
  name: "OrderInProgressTodoView",
  props: {
    businessId: String,
    query: String,
    targetEntityId: String,
    filters: Object,
  },
  components: { ItemsList },
  methods: {
    assign(item) {
      this.$emit("assign", item);
    },
    assignLocation(item) {
      this.$emit("assign-location", item);
    },
    history(item) {
      this.$emit("history", item);
    },
    del(item) {
      this.$emit("del", item);
    },
  },
};
</script>
